/*
 * @Author: your name
 * @Date: 2022-01-21 11:17:24
 * @LastEditTime: 2022-10-19 17:05:26
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /qjh-xiaoxxx-cn/src/api/api.js
 */
import { requestPOST } from "./request.js";

// 案例标签列表
export function labelList(data) {
  return requestPOST(`/api/cases/getLabelList`, data)
}
// 案例列表
export function caseList(data) {
  return requestPOST(`/api/cases/getList`, data)
}
// 案例点击数
export function caseClick(data) {
  return requestPOST(`/api/cases/clickCase`, data)
}